/**
 * this file combines all actions creators
 *
 * Created by Tom on 23/05/18
 */

import * as RouterActions from './routerActions'
import * as ComponentActions from './componentActions'
import * as PortfolioActions from './portfolioActions'
import * as InvestmentActions from './investmentActions'
import * as TransactionActions from './transactionActions'
import * as NewsActions from './newsActions'

export const ActionCreator = Object.assign({},

    // add all action creators here
    RouterActions,
    ComponentActions,
    PortfolioActions,
    InvestmentActions,
    TransactionActions,
    NewsActions
)



// WEBPACK FOOTER //
// ./src/actions/index.js